"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
function updateDataset(oldVNode, vNode) {
  // eslint-disable-line complexity
  var elm = vNode.elm;
  var oldDataset = oldVNode.data.dataset || {};
  var dataset = vNode.data.dataset || {};
  var key = void 0;

  for (key in oldDataset) {
    if (!dataset[key]) {
      delete elm.dataset[key];
    }
  }
  for (key in dataset) {
    if (oldDataset[key] !== dataset[key]) {
      elm.dataset[key] = dataset[key];
    }
  }
}

var DatasetModule = {
  create: updateDataset,
  update: updateDataset
};

exports.DatasetModule = DatasetModule;


/** WEBPACK FOOTER **
 ** ./~/@motorcycle/dom/lib/modules/dataset.js
 **/